const skills = {
  language: ["python", "js", "ts", "php", "html", "css"],
  database: ["postgreSql", "mongo", "supabase", "prisma", "drizzle"],
  other: ["liquid", "sass", "scss", "tailwind", "woocommerce", "redis", "docker", "aws", "netlify", "vercel"],
  tool: ["git", "postman", "figma", "vscode", "n8n"],
  framework: ["react", "next", "vue", "express", "fastapi", "streamlit", "wordpress", "shopify", "webflow"],
  ai: ["openai", "anthropic", "gemini", "openrouter", "huggingface", "ollama"]
};

export default skills;
